import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

// Selectors:
import { searchTypeSelector } from 'src/store/view/selectors';
import { touristsSkipDocSelector } from 'src/store/tourists/selectors';
import {
  getInsuranceType,
  getInsurancePrice,
} from '../../store/selectors/order';
import { getIsInsurable } from '../../store/selectors/package';

// Actions:
import { toggleInsuranceAction } from '../../store/actions/order';

import { ExtraInsurance } from './ExtraInsurance';

const mapStateToProps = (state) => ({
  insurancePrice: getInsurancePrice(state),
  insurable: getIsInsurable(state),
  selectedInsurance: getInsuranceType(state),
  isTouristsSkipDoc: touristsSkipDocSelector(state),
  searchType: searchTypeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  toggleInsurance: (payload) => dispatch(toggleInsuranceAction(payload)),
});

const connector = connect(mapStateToProps, mapDispatchToProps);

export type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(ExtraInsurance);
